<template>
  <div>
    <div v-if="loading" class="text-center py-2">
      <i class="fas fa-spinner fa-spin" />
    </div>
    <div v-else-if="!rows.length" class="text-muted small">
      Nenhum dispositivo passou por esta atribuição.
    </div>
    <div v-else class="table-responsive">
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th>Dispositivo</th>
            <th>Entrou</th>
            <th>Saiu</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>
              {{ deviceLabel(row.device) }}
              <span v-if="row.is_primary" class="badge badge-light-primary ml-1">Principal</span>
            </td>
            <td>
              {{ formatDate(row.created_at) }}
              <small v-if="row.attached_by" class="text-muted d-block">{{ row.attached_by.name }}</small>
            </td>
            <td>
              <span v-if="row.ended_at">{{ formatDate(row.ended_at) }}</span>
              <span v-else class="badge badge-light-success">No veículo</span>
              <small v-if="row.ended_by" class="text-muted d-block">{{ row.ended_by.name }}</small>
            </td>
            <td>{{ row.end_reason || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'AssignmentDeviceHistory',
  props: {
    assignmentId: { type: [String, Number], required: true },
  },
  data() {
    return {
      rows: [],
      loading: false,
    }
  },
  watch: {
    assignmentId: {
      immediate: true,
      handler() {
        this.load()
      },
    },
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const response = await axios.get(`${this.$store.state.api}vehicle_assignments/${this.assignmentId}/device-history`)
        this.rows = response.data.data || []
      } catch (error) {
        this.$error(error)
      } finally {
        this.loading = false
      }
    },
    deviceLabel(device) {
      if (!device) return '—'
      const identifier = device.imei || device.serial_number || device.mac_address || device.android_id || device.id
      return device.description ? `${device.description} - ${identifier}` : String(identifier)
    },
    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '—'
    },
  },
}
</script>
